import trimStart from 'lodash/trimStart';

export default function getThemeDetailsFactory(ajax, getSession) {
  return async function getThemeDetails({ link }) {
    link = trimStart(link, '/');
    return ajax({ resource: link });
  };
}



// WEBPACK FOOTER //
// ./src/services/getThemeDetails.js